<template>
  <div class="d-flex-100 align-content-start adv_product_gallery">
    <!-- Desktop Version -->
    <div class="product-page-single-img" v-if="mainImage && !isMobile">
      <a :href="mainImage['large']" class="image-popup-vertical-fit">
        <div class="thumbnail_container">
          <div class="thumbnail">
            <img :src="mainImage['large']" :alt="truncatedProductName" :title="truncatedProductName" class="imagepop"/>
          </div>
        </div>
      </a>
    </div>
    <div class="prod-gallery-row-wrapper native_slider" v-if="galleryImages.length > 1 && !isMobile">
      <button
        data-scroll_left_by="-1"
        aria-label="Previous"
        class="native_slider-btn native_slider-btn-prev"
      >Prev</button>
      <div class="prod-gallery-row native_slider-lg">
        <span class="prod-gallery-thumb native_slider-li" v-for="navigationThumbs in galleryImagesSorted">
          <div class="thumbnail_container">
            <div class="thumbnail">
              <img :src="navigationThumbs['small']"
                   class="prod-gallery-thumb-img"
                   @click="mainImage = navigationThumbs"
                   :alt="truncatedProductName"
                   :title="truncatedProductName"
              />
            </div>
          </div>
        </span>
      </div>
      <button
        data-scroll_left_by="1"
        aria-label="Next"
        class="native_slider-btn native_slider-btn-next"
      >Next</button>
    </div>

    <!-- Mobile Version -->
    <div class="prod-gallery-mobile native_slider" v-if="isMobile">
      <div class="prod-gallery-row ">
      <button data-scroll_left_by="-1" aria-label="Previous" class="native_slider-btn native_slider-btn-prev">Prev</button>
        <div class="prod-gallery-thumb native_slider-lg " >
          <div class="thumbnail_container native_slider-li" v-for="image in galleryImages">
            <div class="thumbnail">
              <img :src="image['large']"
                   class="prod-gallery-thumb-img"
                   :alt="truncatedProductName"
                   :title="truncatedProductName"
              />
            </div>
          </div>
        </div>
      <button data-scroll_left_by="1" aria-label="Next" class="native_slider-btn native_slider-btn-next">Next</button>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../vue/store'
import productMixin from './mixins/productMixins'
// import AdvHtmlPicture from '../../vue/components/AdvHtmlPicture.vue'

export default {
  name: 'AdvProductGallery',
  // components: {
  //   AdvHtmlPicture,
  // },
  props: {
    productId: {
      type: Number,
      // required: true,
    },
    productName: {
      type: String,
      // required: true,
    },
    mainImageFirst: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mixins: [productMixin],
  data() {
    return {
      productCodeId: null,
      mainImage: null,
      galleryImages: [{
        is_main: '1',
        original: store.state.noImage,
        small: store.state.noImage,
        medium: store.state.noImage,
        large: store.state.noImage
      }],
      isMobile: window.innerWidth <= 768
    }
  },
  computed: {
    selectedAttributeId() {
      return store.getters.getSelectedAttributeId
    },
    truncatedProductName() {
      const name = this.productName || ''
      return name.length > 70 ? name.slice(0, 67) + '...' : name
    },
    selectedProductCodeId() {
      return store.getters.getSelectedProductCodeId
    },
    galleryImagesSorted() {
      if (!this.mainImageFirst) {
        return this.galleryImages
      }
      const images = this.galleryImages
      return images.sort(function (a, b) {
        return a.is_main === '1' ? -1 : b.is_main === '1' ? 1 : 0
      })
    }
  },
  watch: {
    selectedProductCodeId(val) {
      this.productCodeId = val
      this.setUpGalleryUpdate()
    },
    selectedAttributeId(attributeId) {
      const productCode = this.productData.productCodes.find(item => item.productCodeAttributes.includes(attributeId))
      this.setUpGalleryUpdate(productCode.productCodeId)
    }
  },
  mounted() {
    this.setProductCodeId()
    this.setUpGalleryUpdate()
    window.addEventListener("resize", this.checkMobile)
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkMobile)
  },
  // computed: {
  //   selectedAttributeId() {
  //     return store.getters.getSelectedAttributeId;
  //   },
  //   selectedProductCodeId() {
  //     return store.getters.getSelectedProductCodeId;
  //   },
  //   galleryMediaSorted() {
  //     if (!this.mainImageFirst) {
  //       return this.galleryMedia
  //     }
  //     const images = [...this.galleryMedia]
  //     return images.sort(function (a, b) { return a.is_main === '1' ? -1 : b.is_main === '1' ? 1 : 0 })
  //   },
  //   videoEmbedUrl() {
  //     if (!this.currentVideo) return null;
  //     const videoType = this.currentVideo.type.toLowerCase();
  //     const videoId = this.currentVideo.uri;
  //     switch (videoType) {
  //       case 'youtube':
  //         return `https://www.youtube.com/embed/${videoId}`;
  //       case 'vimeo':
  //         return `https://player.vimeo.com/video/${videoId}`;
  //       case 'tiktok':
  //         return `https://www.tiktok.com/embed/v3/${videoId}`;
  //       case 'instagram':
  //         return `https://www.instagram.com/reel/${videoId}/embed/`;
  //       case 'facebook':
  //         return `https://www.facebook.com/plugins/video.php?href=https://www.facebook.com/watch?v=${videoId}`;
  //       default:
  //         return null;
  //     }
  //   },
  // },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768
    },
    setUpGalleryUpdate(codeId = null) {
      this.productCodeImages(codeId)
      this.setMainImage()
    },
    setProductCodeId() {
      if (this.selectedProductCodeId) {
        this.productCodeId = this.selectedProductCodeId
      } else {
        this.productCodeId = parseInt(Object.keys(this.productData.images)[0])
      }
    },
    productCodeImages(codeId = null) {
      if (!(codeId === null)) {
        this.galleryImages = this.productData.images[parseInt(codeId)]
      } else if (!(this.productCodeId === null)) {
        this.galleryImages = this.productData.images[this.productCodeId]
      }
    },
    setMainImage() {
      this.mainImage = this.galleryImages.find(image => image.is_main === '1')
    }
  }
}
</script>
